import FeatureSwitches from "../../../config/FeatureSwitches";
export default class threekitApi {
  constructor(authToken, orgID, host, uploadHost) {
    this.token = authToken;
    this.orgID = orgID;
    this.host = host;
    this.uploadHost = uploadHost;
    const featureSwitch = new FeatureSwitches();
    this.features = featureSwitch.setFeatures();
  }

  auth = () => `bearer_token=${this.token}&orgId=${this.orgID}`;

  async getSnapShotUrl(productId) {
    await window.playerObj.selectionSet.clear();
    let base64Img = await window.playerObj.api.snapshotAsync();
    // Getting Blob from base64 then converting it to file

    let imgBlob = await fetch(base64Img)
      .then((res) => res.blob())
      .then((res) => {
        return res;
      });

    // Saving file to configuration

    const imgFile = new File([imgBlob], "thumbnail.png");
    //console.log(imgFile);

    var myHeaders = new Headers();
    let variant = {
      ExampleVariantField1: "ExampleValue1",
    };
    var formdata = new FormData();
    formdata.append("files", imgFile);
    formdata.append("orgId", this.orgID);
    formdata.append("productId", productId);
    formdata.append("productVersion", "snapshot1.0");

    formdata.append("variant", JSON.stringify(variant));

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: formdata,
      redirect: "follow",
    };
    //console.log(imgFile);
    let response = await fetch(
      `https://${this.host}/api/configurations?bearer_token=` + this.token,
      requestOptions
    )
      .then((response) => response.text())
      .then((result) => {
        return JSON.parse(result);
      })
      .catch((error) => console.log("error", error));
    // console.log(response);

    let finalUrl = `https://${this.host}/api/files/hash/` + response.thumbnail;

    return finalUrl;
  }

  isMobileDevice() {
    var agent = navigator.userAgent;
    return (
      /(android)/i.test(agent) ||
      (/iPad|iPhone|iPod/.test(agent) && !window.MSStream)
    );
  }
  
  async uploadFileToThreeKit(filedata) {
    var jobIdGlobal;
    var formdata = new FormData();
    formdata.append("orgID", this.orgID);
    formdata.append("files", filedata);
    var requestOptionsUpload = {
      method: "POST",
      body: formdata,
      redirect: "follow",
    };

    var uploadPath =
      this.isMobileDevice() || this.features.proxyAllUploads
        ? `https://${this.uploadHost}/api/public/catalog/assets/upload?`
        : `https://${this.host}/api/catalog/assets/upload?`;

    await fetch(uploadPath + this.auth(), requestOptionsUpload)
      .then((response) => response.json())
      .then((result) => {
        jobIdGlobal = result[0].jobId;
      })
      .catch((error) => console.log("error", error));
    return jobIdGlobal;
  }
  async getAssetIDfromJob(jobID) {
    var imageassetId;
    var imagefileId;
    var job_status;
    var requestOptionsAsset = {
      method: "GET",
      redirect: "follow",
    };
    await fetch(
      `https://${this.host}/api/catalog/jobs/` + jobID + "?" + this.auth(),
      requestOptionsAsset
    )
      .then((responseAsset) => responseAsset.json())
      .then(
        (resultAsset) => {
          job_status = resultAsset.job.status;
          if (job_status === "stopped") {
            imageassetId = resultAsset?.output?.texture[0]?.assetId;
            imagefileId = resultAsset?.job?.parameters?.files[0].fileId;
          }
        } //end then resultAsset
      ) //end then resultAsset
      .catch((error) => console.log("error", error));
    return { job_status, imageassetId, imagefileId };
  }
  // async checkCart() {
  //   console.log("checking");
  //   const result = { nextDayShipping: false, digitalProof: false };
  //   // await $.ajax({
  //   //   type: "GET",
  //   //   url: "/cart.js",
  //   //   cache: false,
  //   //   dataType: "json",
  //   //   success: function (cart) {
  //   //     let items = cart.items;
  //   //     items.forEach((item) => {
  //   //       if (
  //   //         item.product_title == "NEXT DAY SHIPPING" ||
  //   //         item.properties["Next Day Shipping"]?.toLowerCase().includes("yes")
  //   //       ) {
  //   //         result.nextDayShipping = true;
  //   //       }
  //   //       if (
  //   //         item.product_title == "DIGITAL PROOF" ||
  //   //         item.properties["Digital Proof"]?.toLowerCase().includes("yes")
  //   //       ) {
  //   //         result.digitalProof = true;
  //   //       }
  //   //     });
  //   //   },
  //   // });
  //   // if (result.nextDayShipping && result.digitalProof) {
  //   //   alert(
  //   //     "The cart contains both Next Day Shipping and Digital Proof items. This is an error, as digital proof isn't possible on Next Day Shipping orders."
  //   //   );
  //   // }
  //   return result;
  // }
  // getOptionsForm = (productID, func) => {
  //   // return $.ajax({
  //   //   url: "https://137.184.223.104/frontend/getProductOptions.php",
  //   //   data: { product_id: productID },
  //   //   type: "POST",
  //   //   dataType: "json",
  //   //   success: func,
  //   // });
  // };
}
